import React, { lazy, Suspense, useCallback, useContext, useMemo, useState } from 'react';
import { useLazyFetchSearchResultsQuery } from '../../features/search/searchApi';
import { SearchOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { SearchContext } from '../../context/searchProvider';
import { Button, Card, Input, Space } from 'antd';
import { WORKSPACE_FILTER_TYPES } from '../UserSpace/constant';
import Search from 'antd/es/input/Search';

const SearchUI = lazy(() => import('./SearchUI'));

const index = (props) => {
  const { hideIcon = false, width = 475, onlyIcon = false } = props;
  const {
    searchVisiblity: visible,
    changeSearchVisiblity: setVisible,
    workspacesOnly,
    setWorkspacesOnly,
  } = useContext(SearchContext);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [filterType, setFilterType] = useState('');
  const navigate = useNavigate();
  const [triggerSearch, { data, isFetching, isLoading, isError, error, reset }] = useLazyFetchSearchResultsQuery();
  const { newWorkspaceList } = useSelector((state) => state.organization);

  const handleKeyDown = useCallback(
    (e) => {
      if (!data) return;

      const totalItems = (data.docs?.length || 0) + (data.workspaces?.length || 0);
      if (e.key === 'ArrowUp') {
        setSelectedIndex((prev) => (prev > 0 ? prev - 1 : totalItems - 1));
      } else if (e.key === 'ArrowDown') {
        setSelectedIndex((prev) => (prev < totalItems - 1 ? prev + 1 : 0));
      } else if (e.key === 'Enter' && selectedIndex >= 0) {
        event.preventDefault();
        event.stopPropagation();
        const selectedItem =
          selectedIndex < (data.docs?.length || 0)
            ? data.docs[selectedIndex]
            : data.workspaces[selectedIndex - (data.docs?.length || 0)];
        if (selectedItem?.url) {
          navigate(selectedItem.url);
          setVisible(false);
        }
      }
    },
    [data, setSelectedIndex, selectedIndex, setVisible]
  );
  const openSearchModal = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (props?.workspaceOnly) {
        setWorkspacesOnly(true);
      }
      setVisible(true);
    },
    [props?.workspaceOnly, setWorkspacesOnly, setVisible]
  );

  return (
    <div onKeyDown={handleKeyDown} tabIndex={0} style={{ outline: 'none', width: '100%' }}>
      <div onClick={openSearchModal}>
        {onlyIcon ? (
          <SearchOutlined style={{ cursor: 'pointer', fontSize: '20px' }} />
        ) : (
          <Search
            placeholder="Search “document”"
            style={{
              flex: 1,
              maxWidth: 475,
              width: '100%',
              height: 40,
              pointerEvents: 'none', // Disables all mouse events
              cursor: 'pointer', // Shows default cursor instead of text input cursor
              display: 'flex',
              alignItems: 'center',
            }}
            readOnly // Makes the input read-only
            tabIndex={-1} // Removes from tab order
          />
        )}
      </div>
      {visible && (
        <Suspense fallback={null}>
          <SearchUI
            setVisible={setVisible}
            triggerSearch={triggerSearch}
            data={data}
            isFetching={isFetching}
            isLoading={isLoading}
            isError={isError}
            error={error}
            reset={reset}
            setSelectedIndex={setSelectedIndex}
            selectedIndex={selectedIndex}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            setWorkspacesOnly={setWorkspacesOnly}
            workspacesOnly={workspacesOnly}
            filterType={filterType}
            setFilterType={setFilterType}
            filterTypes={WORKSPACE_FILTER_TYPES}
          />
        </Suspense>
      )}
    </div>
  );
};

export default index;
